export default "__VITE_ASSET__B3y__IpG__"